import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './image/eco-btn-swiper.png';
var _hoisted_1 = {
  class: "swiper_box"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "swiper_text_box_aboutUs"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "jump_detail_btn"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "swiper_text_aboutUs"
}, "向元新生"), /*#__PURE__*/_createElementVNode("div", {
  class: "swiper_text_aboutUs"
}, "羿护未来")], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_BannerSwiper = _resolveComponent("BannerSwiper");

  var _component_Content = _resolveComponent("Content");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_BannerSwiper, {
    bannerList: $setup.bannerList
  }, {
    default: _withCtx(function () {
      return [_hoisted_2];
    }),
    _: 1
  }, 8, ["bannerList"])]), _createVNode(_component_Content)], 64);
}